import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from '@chakra-ui/react';
import SettlementOverview from './SettlementOverview';
import TaxAccountManagement from './TaxAccountManagement';
import SettlementClearing from './SettlementClearing';
import SettlementPaymentHistory from './SettlementPaymentHistory';
import SettlementBreakdown from './SettlementBreakdown';

const SettlementManagement = () => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box p={6} bg={bgColor} borderRadius="lg" border="1px" borderColor={borderColor}>
      <VStack spacing={6} align="stretch">
        {/* Header */}
        <VStack align="start" spacing={1}>
          <Heading size="lg" color="blue.600">
            Settlement Management
          </Heading>
          <Text color="gray.600">
            Manage settlement accounts, payments, and track settlement history
          </Text>
        </VStack>

        {/* Tabs */}
        <Tabs variant="enclosed" colorScheme="blue">
          <TabList>
            <Tab>Overview</Tab>
            <Tab>Tax Account</Tab>
            <Tab>Settlement Clearing</Tab>
            <Tab>Payment History</Tab>
            <Tab>Settlement Breakdown</Tab>
          </TabList>
          
          <TabPanels>
            <TabPanel px={0}>
              <SettlementOverview />
            </TabPanel>
            
            <TabPanel px={0}>
              <TaxAccountManagement />
            </TabPanel>
            
            <TabPanel px={0}>
              <SettlementClearing />
            </TabPanel>
            
            <TabPanel px={0}>
              <SettlementPaymentHistory />
            </TabPanel>
            
            <TabPanel px={0}>
              <SettlementBreakdown />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </Box>
  );
};

export default SettlementManagement;

